import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../../models/session/sessionState";
import { IUnitModuleNode } from "../../../../models/unit/unitModuleNode";
import { PermissionIcon } from "../../../framework/Icon/PermissionIcon";
import { UnitModuleTreeNode } from "../UnitModuleTreeNode";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

interface IUnitModuleTreeProp {
    sessionState: ISessionState;
    classes?: string;
    unitModuleNodes: IUnitModuleNode[];
    selectedId?: string;
    isFirstNode: boolean;
    oneModuleUnitsMode?: boolean;
    canEditWhistleBlowSettings: boolean;
    onClick: (id: string) => void;
    onDoubleClick: () => void;
    onSetUsage: (id: string, applicationPermissionType: ApplicationPermissionType, value: boolean) => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export const UnitModuleTree = (props: IUnitModuleTreeProp) => {
    const unitModuleNodes = props.unitModuleNodes;
    if (!unitModuleNodes) return null;

    return (
        <>
            <VerticalContainer
                before={
                    <Grid container sx={{ backgroundColor: "action.hover", borderBottom: "1px solid", borderColor: "divider", padding: "0 1rem" }}>
                        <Grid item sm={props.oneModuleUnitsMode ? 5 : 3}>
                            <Box sx={{ cursor: "default", padding: "9px 0" }}>
                                <Typography>{Translations.Unit}</Typography>
                            </Box>
                        </Grid>
                        <Grid item sm={props.oneModuleUnitsMode ? 5 : 3}>
                            <Box sx={{ cursor: "default", padding: "9px 0" }}>
                                <Typography>{Translations.Description}</Typography>
                            </Box>
                        </Grid>
                        <Grid item sm={props.oneModuleUnitsMode ? 2 : 6}>
                            {unitModuleNodes.length > 0 &&
                                <Box display="flex" alignItems="center" sx={{ cursor: "default", padding: "9px 0" }}>
                                    {props.oneModuleUnitsMode
                                        ? (<Typography>{Translations.InUse}</Typography>)
                                        : (
                                            <Grid container>
                                                {unitModuleNodes[0].usages.filter(i => i.visible).map((usage) => (
                                                    <Grid item xs key={usage.applicationPermissionType} sx={{ marginLeft: ".5rem" }}>
                                                        <PermissionIcon type={usage.applicationPermissionType} title={usage.getTitle(props.sessionState.isSuperAdmin, props.sessionState.canUseRecords)} />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        )
                                    }
                                </Box>
                            }
                        </Grid>
                    </Grid>
                }
                main={
                    <Box sx={{
                        height: "100%",
                        overflowX: "hidden",
                        overflowY: "auto",
                    }}>
                        {unitModuleNodes.map((unitModuleNode, index) =>
                            <UnitModuleTreeNode
                                key={unitModuleNode.id}
                                unitModuleNode={unitModuleNode}
                                selectedId={props.selectedId}
                                isFirstNode={index < 1}
                                oneModuleUnitsMode={props.oneModuleUnitsMode}
                                canEditWhistleBlowSettings={props.canEditWhistleBlowSettings}
                                onClick={props.onClick}
                                onDoubleClick={props.onDoubleClick}
                                onSetUsage={props.onSetUsage}
                                onSetCollapsed={props.onSetCollapsed}
                            />
                        )}
                    </Box>
                }
            />
        </>
    );
};